import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useLocation,useNavigate } from 'react-router-dom';
import { fetchCustomPlant, updateCustomPlant } from '../../../api/api_customPlants';
import loadingGif from '../../assets/loading.gif';

function EditCustomPlant() {
  const { translations } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const [customPlant, setCustomPlant] = useState(null);
  const [name, setName] = useState('');
  const [max_Temperature, setMax_Temperature] = useState('');
  const [max_Minerals, setMax_Minerals] = useState('');
  const [max_GroundHumidity, setMax_GroundHumidity] = useState('');
  const [max_AirHumidity, setMax_AirHumidity] = useState('');
  const [min_Temperature, setMin_Temperature] = useState('');
  const [min_Minerals, setMin_Minerals] = useState('');
  const [min_GroundHumidity, setMin_GroundHumidity] = useState('');
  const [min_AirHumidity, setMin_AirHumidity] = useState('');
  const [sunlight_level, setSunlightLevel] = useState('0');

  const sunlightLevelOptions = [
    { value: 0, label: translations.no_light },
    { value: 1, label: translations.low_ambient_light },
    { value: 2, label: translations.ambient_light },
    { value: 3, label: translations.indirect_solar_light },
    { value: 4, label: translations.direct_solar_light }
  ];

  useEffect(() => {
    const { customPlant } = location.state;
    if (customPlant) {
        fetchCustomPlant(customPlant.id)
            .then(response => {
                if (response.error) {
                    console.error('Error fetching custom plant:', response.message);
                    navigate('/home');
                } else {
                    const plant = response.data;
                    setCustomPlant(plant);
                    setName(plant.name);
                    setMax_Temperature(plant.max_temperature);
                    setMax_Minerals(plant.max_minerals);
                    setMax_GroundHumidity(plant.max_ground_humidity);
                    setMax_AirHumidity(plant.max_air_humidity);
                    setMin_Temperature(plant.min_temperature);
                    setMin_Minerals(plant.min_minerals);
                    setMin_GroundHumidity(plant.min_ground_humidity);
                    setMin_AirHumidity(plant.min_air_humidity);
                    setSunlightLevel(plant.sunlight_level);
                }
            })
            .catch(error => {
                console.error('Error fetching custom plant:', error);
                navigate('/home');
            });
    } else {
        navigate('/home');
    }
  }, [navigate, location]);

  const formatTemperature = (temp) => {
    const number = parseFloat(temp);
    return (number % 1 === 0.5 || number % 1 === 0) ? number.toFixed(1) : Math.round(number).toFixed(1);
  };

  const handleTemperatureChange = (value, setter) => {
    const validValue = formatTemperature(value);
    setter(validValue);
  };

  const handleSave = () => {
    const { customPlant } = location.state;
    const token = localStorage.getItem('userToken');
    const updatedCustomPlant = { ...customPlant, name, max_Temperature, max_Minerals, max_GroundHumidity, max_AirHumidity, min_Temperature, min_Minerals, min_GroundHumidity, min_AirHumidity, sunlight_level };
    updateCustomPlant(customPlant.id, updatedCustomPlant, token)
      .then(() => {
        navigate('/customPlants');
      })
      .catch(error => {
        console.error('Error updating custom plant:', error);
      });
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="plant-page">
      <div className="sm-container">
      <div className="header">
        <button onClick={handleBack} className="back-button">&#8592;</button>
        <h1>{translations.custom_plant_edit}</h1>
      </div>
      {customPlant ? (
          <div className="form-container">
              <div className="input-group full-width ">
                  <label htmlFor="name">{translations.name}</label>
                  <input id="name" type="text" className="general-input" value={name} onChange={(e) => setName(e.target.value)} required />
              </div>
              <div className="input-group">
                  <label htmlFor="max_Temperature">{translations.max_temperature}</label>
                  <input id="max_Temperature" type="text" className="general-input" value={max_Temperature} onChange={(e) => handleTemperatureChange(e.target.value, setMax_Temperature)} required />
              </div>
              <div className="input-group">
                  <label htmlFor="min_Temperature">{translations.min_temperature}</label>
                  <input id="min_Temperature" type="text" className="general-input" value={min_Temperature} onChange={(e) => handleTemperatureChange(e.target.value, setMin_Temperature)} required />
              </div>
            <div className="input-group">
                  <label htmlFor="max_GroundHumidity">{translations.max_soil_moisture}</label>
                  <input id="max_GroundHumidity" type="number" className="general-input" value={max_GroundHumidity} onChange={(e) => setMax_GroundHumidity(e.target.value)} required />
              </div>
              <div className="input-group">
                  <label htmlFor="min_GroundHumidity">{translations.min_soil_moisture}</label>
                  <input id="min_GroundHumidity" type="number" className="general-input" value={min_GroundHumidity} onChange={(e) => setMin_GroundHumidity(e.target.value)} required />
              </div>
              <div className="input-group">
                  <label htmlFor="max_AirHumidity">{translations.max_air_humidity}</label>
                  <input id="max_AirHumidity" type="number" className="general-input" value={max_AirHumidity} onChange={(e) => setMax_AirHumidity(e.target.value)} required />
              </div>
              <div className="input-group">
                  <label htmlFor="min_AirHumidity">{translations.min_air_humidity}</label>
                  <input id="min_AirHumidity" type="number" className="general-input" value={min_AirHumidity} onChange={(e) => setMin_AirHumidity(e.target.value)} required />
              </div>
              <div className="input-group">
                  <label htmlFor="max_Minerals">{translations.max_minerals}</label>
                  <input id="max_Minerals" type="number" className="general-input" value={max_Minerals} onChange={(e) => setMax_Minerals(e.target.value)} required />
              </div>
              <div className="input-group">
                  <label htmlFor="min_Minerals">{translations.min_minerals}</label>
                  <input id="min_Minerals" type="number" className="general-input" value={min_Minerals} onChange={(e) => setMin_Minerals(e.target.value)} required />
            </div>
            <div className="input-group full-width">
              <label htmlFor="sunlightLevel">{translations.sunlight_level}</label>
              <select id="sunlightLevel" className="general-input" value={sunlight_level} onChange={(e) => setSunlightLevel(e.target.value)} required>
                {sunlightLevelOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <button onClick={handleSave} className="general-button full-width ">{translations.save}</button>
          </div>
      ) : (
          <div className='pot-loading'> <img src={loadingGif} alt={translations.loading} /> </div>
      )}
      </div>
    </div>
    );
    }

export default EditCustomPlant;
